const options = {
    item: 'js-decision-tree',
    result: 'js-decision-tree-result',
    answer: 'js-decision-tree-answer',
    fallback: 'js-decision-tree-fallback',
};

const decisionTreeBlock = {
    init() {
        const items = document.getElementsByClassName(options.item)
        ? document.getElementsByClassName(options.item)
            : [];

        if (Array.isArray(items) && !items.length) return;

        Array.prototype.forEach.call(items, (item) => {
            const answers = item.getElementsByClassName(options.answer);
            let answerValues = [];
            
            if (Array.isArray(answers) && !answers.length) return;

            item.classList.remove('js-decision-tree--not-ready');
            item.setAttribute('aria-busy', 'false');
            Array.prototype.forEach.call(answers, (answer) => {
                answer.removeAttribute('disabled');
            });

            Array.prototype.forEach.call(answers, (answer) => {

                answer.addEventListener('change', () => {
                    const results = item.getElementsByClassName(options.result)
                    ? item.getElementsByClassName(options.result)
                        : [];
                    const fallback = item.getElementsByClassName(options.fallback)
                    ? item.getElementsByClassName(options.fallback)[0]
                        : [];
                    const answerKey = answer.dataset.answerKey;

                    answerValues[answerKey] = answer.value;
                    fallback.style.display = 'none';
                    
                    let hasMatch = false;
                    Array.prototype.forEach.call(results, (r) => { r.style.display = 'none'; });
                    const filledCount = answerValues.filter(
                        (value) => value !== null && value !== undefined && value !== ''
                    ).length;

                    for (let i = 0; i < results.length; i++) {
                        const result = results[i];
                        const valueSets = (result.dataset.andValues || '').split('|');

                        for (let s = 0; s < valueSets.length; s++) {
                            const resultValues = valueSets[s].trim().split(/\s+/).filter(Boolean);
                            const resultSet = new Set(resultValues);

                            if (filledCount !== resultValues.length) {
                                continue;
                            }

                            if (answerValues.every((value) => resultSet.has(value))) {
                                result.style.display = 'flex';
                                hasMatch = true;
                                break;
                            }
                        }
                        if (hasMatch) break;
                    }

                    if (fallback) {
                        const numQuestions = new Set(Array.from(answers).map((a) => a.dataset.answerKey)).size;
                        const allAnswered = filledCount === numQuestions;
                        fallback.style.display = !hasMatch && allAnswered ? 'flex' : 'none';
                    }
                });
            });
        });
    },
};

window.addEventListener('load', () => {
    if (window.acf) {
        setTimeout(() => {
        const block = document.querySelector('[data-type="acf/decision-tree"]');
        const observer = new MutationObserver((mutations) => {
            mutations.forEach(() => {
                decisionTreeBlock.init();
            });
        });

        if (block) {
            decisionTreeBlock.init();
            observer.observe(block, { childList: true, subtree: false });
        }
        }, 1000);
    } else {
        decisionTreeBlock.init();
    }
});
  